module.exports = __webpack_public_path__ + "Social-2f538d59f2458bb21464e7cf60b7f9c7.png";